import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {

    keys: string[] = [];

    get show(): boolean {
        return this.keys.length > 0;
    }

    add(key: string) {
        if (this.keys.indexOf(key) < 0) {
            this.keys.push(key);
        }
    }

    dismiss() {
        this.keys.length = 0;
    }

    remove(key: string) {
        for (var i = this.keys.length - 1; i >= 0; i--) {
            if (this.keys[i] === key) {
                this.keys.splice(i, 1);
            }
        }
    }
}